module.exports = __webpack_public_path__ + "img/SA.820982e9.jpg";